import { Flex, Heading, Text, Button } from "@chakra-ui/react";
import ImageCarrousel from "../../components/ImageCarrousel";
import StoreCards from "../../components/StoreCards";
import PricingCards from "../../components/PricingCards";
import Comments from "../../components/Comments";
import { LinkIcon } from '@chakra-ui/icons'

const BANNERS = [
    {
        url: '/images/airpods.jpg',
        alt: 'Airpods'
    },
    {
        url: '/images/camera.jpg',
        alt: 'Camera'
    },
    {
        url: '/images/mouse.jpg',
        alt: 'Mouse'
    }
]

const HomePageContent = () => {
    return (
        <Flex
            flex={1}
            minH="100vh"
            flexDirection={'column'}
        >
            <ImageCarrousel images={BANNERS} />
            <Flex px={10} py={20} flexDir='column' mb={0}>
                <Heading as="h1" size="lg" mb={1}>
                    Bienvenido a Skyshops
                </Heading>
                <Text mb={5}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text>
                <Flex w='100%' flex={1} flexDirection={'column'}>
                    <StoreCards />
                </Flex>
            </Flex>
            <Flex 
                bg={'gray.100'}
                px={10} flexDir='column' mb={15}
                py={20}
            >
                <Heading as="h1" size="lg" mb={1}>
                    Planes Skyshops
                </Heading>
                <Text mb={5}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text>
                <Flex flex={1} flexDirection={'column'}>
                    <PricingCards />
                </Flex>
                <Button
                    colorScheme="blue"
                    variant="outline"
                    size="md"
                    mt={10}
                    alignSelf='center'
                >
                    Conoce más
                    <LinkIcon ml={2} />
                </Button>
            </Flex>
            <Flex px={10} py={10} flexDir='column'>
                <Heading as="h1" size="lg" mb={1}>
                    Comentarios
                </Heading>
                <Text mb={5}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Text>
                <Flex flex={1} flexDirection={'column'}>
                    <Comments />
                </Flex>
                <Button
                    colorScheme="blue"
                    variant="outline"
                    size="md"
                    mt={10}
                    alignSelf='center'
                >
                    Ver más comentarios
                    <LinkIcon ml={2} />
                </Button>
            </Flex>
        </Flex>
    )
}

export default HomePageContent;